import Api from 'services/PtmApi';
import { LoginService } from 'services/LoginService';
import { ApiError, returnApiError } from 'models/ApiError';
import { HttpStatusCode } from 'models/HttpStatusCode';
import { ImageResource } from 'models/ImageResource';

export class ImageService
{
	private loginService: LoginService;

	constructor(loginService: LoginService)
	{
		this.loginService = loginService;
	}

	public uploadImage(file: File, type: string, id: string): Promise<ImageResource>
	{
		const session = this.loginService.getSession();

		if (session === undefined)
			return Promise.reject("No session");

		if (typeof session.accessToken !== 'string')
			return Promise.reject(ApiError.InvalidAccessToken);

		let url = Api.getBaseUrl() + 'v1/image/' + type + '/' + id;

		const formData = new FormData();
		formData.append('image', file, file.name);

		let init = {
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + session.accessToken
			},
			body: formData
		};

		return fetch(url, init).then((response: Response) =>
		{
			if (response.status === HttpStatusCode.Created)
			{
				return response.json().then(function (json: any)
				{
					console.log(json);

					const resource = ImageResource.fromJson(json);

					console.log(resource);

					if (resource.isValid() === false)
						throw ApiError.ResponseCouldNotBeParsed;

					return resource;
				});
			}
			else
				return response.json().then(returnApiError);
		});
	}

	public deleteImage(type: string, id: string): Promise<void>
	{
		const session = this.loginService.getSession();

		if (session === undefined)
			return Promise.reject("No session");

		if (typeof session.accessToken !== 'string')
			return Promise.reject(ApiError.InvalidAccessToken);

		let url = Api.getBaseUrl() + 'v1/image/' + type + '/' + id;

		const init = {
			method: 'DELETE',
			headers: {
				'Authorization': 'Bearer ' + session.accessToken
			}
		};

		return fetch(url, init).then((response: Response) =>
		{
			if (response.status === HttpStatusCode.OK)
				return Promise.resolve();
			else
				return response.json().then(returnApiError);
		});
	}
}